export default defineNuxtPlugin({
  async setup() {
    const snackbar = reactive({
      snackbar: false,
      text: '',
      timeout: 5000,
      requireAuth: false,
      openSnackbar: (text: string) => {
        snackbar.snackbar = true;
        snackbar.text = text;
      },
      isError: false,
    });
    return {
      provide: {
        snackbar,
      },
    };
  },
});
